import { assetsPlaceholder } from '../../constants/assetsPlaceholder';
import {
  COACH_ENTITY,
  COMPETITION_ENTITY,
  COUNTRY_ENTITY,
  PLAYER_ENTITY,
  TEAM_ENTITY,
  TOURNAMENT_ENTITY,
} from '../../constants/entityTypes';
import { NATIONAL } from '../../constants/sportRegions';

export const setNationalParticipantBorder = (isNational: boolean) => {
  if (!isNational) {
    return {};
  }

  return {
    br: '$round',
    borderRadius: '$radii$round',
    border: '1px solid $countryLogoBorderColor',
  };
};

export const isNationalParticipant = (team: any) => {
  // it is any because it is used in multiple places and each have different model
  // using generics here is not needed because we do not return the whole object but only boolean value
  return team?.type === NATIONAL || team?.type === NATIONAL.toLocaleUpperCase();
};

export const isPlaceholderImage = (participantImage: string | null | undefined) => {
  return participantImage ? participantImage.startsWith('data:image/') : false;
};

export const checkIsPlaceholderOrSetBorder = (participantImage: string | null | undefined) => {
  if (isPlaceholderImage(participantImage)) {
    return {};
  }
  return setNationalParticipantBorder(true);
};

export const setParticipantBorder = (team: unknown, participantImage?: string | null) => {
  if (isPlaceholderImage(participantImage) || !isNationalParticipant(team)) {
    return {};
  }
  return setNationalParticipantBorder(true);
};

export const getFallbackImageByType = (entityType: string) => {
  switch (entityType) {
    case PLAYER_ENTITY:
    case COACH_ENTITY:
      return assetsPlaceholder.participantPlayer;
    case TEAM_ENTITY:
      return assetsPlaceholder.team;
    case COMPETITION_ENTITY:
      return assetsPlaceholder.competition;
    case TOURNAMENT_ENTITY:
      return assetsPlaceholder.tournament;
    case COUNTRY_ENTITY:
      return assetsPlaceholder.country;
    default:
      return assetsPlaceholder.empty;
  }
};
